import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AppProviders } from './app/providers.js';
import { ErrorBoundary } from './components/feedback/error-boundary.js';
import { routes } from './routes/router.js';

/**
 * The application root: providers, then the router.
 *
 * The outer error boundary is the one that catches a failure in the shell itself (a provider,
 * the header, the navigation). The inner one — inside `AppShell` — catches a failure in a
 * single screen and keeps the navigation usable.
 */
const router = createBrowserRouter(routes);

export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  );
}

export default App;
